import script from "./ReportVerify.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportVerify.vue?vue&type=script&setup=true&lang=ts"

import "../style/ReportVerify.css?vue&type=style&index=0&id=969971c2&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-969971c2"]])

export default __exports__